import React from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Box, Button, Card, CardActions, CardContent, Typography} from '@mui/material';

const LibraryList = [
    {
      title: 'Advisory Opinions Index',
      subtitle:
        'View a chronological listing of the opinions issued concerning the application of the campaign finance law.',
      link: '/Legal/AdvisoryOpinionsIndex'
    },
    {
      title: 'Guidance Letters',
      subtitle:
        'Guidance letters answer questions generally not relating to an issue previously addressed by OCPF.',
      link: '/Legal/GuidanceLetters'
    },
    {
      title: 'Interpretive Bulletin Index',
      subtitle:
        'An interpretive bulletin may clarify an aspect of the campaign finance law or provide guidance on how OCPF administers the law in a particular situation.',
      link: '/Legal/InterpretiveBulletinIndex'
    },
    {
      title: 'Memoranda Index',
      subtitle:
        'Memoranda are issued to clarify the application of the Massachusetts campaign finance law to various topics.',
      link: '/Legal/MemorandaIndex'
    },
    {
      title: 'Issues of Interest',
      subtitle:
        'Check the issues that have attracted special interest from the public.',
      link: '/Legal/IssuesOfInterest'
    },
    {
      title: 'Public Financing Law',
      subtitle:
        'Limited Public Financing of Campaigns for Statewide Elective Office.',
      link: '/Legal/PublicFinancingLaw'
    }
  ];

const LegalLibraryList = (): JSX.Element => {

    const theme = useTheme();

    return (
    <Box marginTop={5} marginBottom={4}>
        <Box marginBottom={3}>
        <Typography
           variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary.dark'}
          align={'center'}
        >
          Legal e-Library
        </Typography>
        </Box>
        <Grid container spacing={2}>
          {LibraryList.map((item, i) => (
            <Grid size={{xs:12, md:4}} key={i}>
              <Box
                display={'block'}
                width={1}
                height={1}
                sx={{
                  textDecoration: 'none',
                  transition: 'all .2s ease-in-out',
                  '&:hover': {
                    transform: `translateY(-${theme.spacing(1 / 2)})`,
                  },
                }}
              >
                <Box
                  component={Card}
                  width={1}
                  height={1}
                  data-aos={'fade-up'}
                  data-aos-delay={i * 100}
                  data-aos-offset={200}
                  data-aos-duration={600}
                  display={'flex'}
                  flexDirection={'column'}
                  bgcolor={'alternate.main'}
                >
                  <CardContent>
                    <Typography
                      variant={'h6'}
                      gutterBottom
                      sx={{ fontWeight: 500 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography color="text.secondary">
                      {item.subtitle}
                    </Typography>
                  </CardContent>
                  <Box flexGrow={1} />
                  <CardActions sx={{ justifyContent: 'flex-end', paddingX: 4 }}>
                    <Button size="large" href={item.link}>Learn More</Button>
                  </CardActions>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
    </Box>
    )

}

export default LegalLibraryList;